<template>
    <nav class="navbar is-light is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <router-link to="/home" class="navbar-item"><span class="text_title" style="padding-left:4px;font-size:1.1em;font-weight:bold;color:#27546A;">{{ $t("message.header_title") }}</span>
        </router-link>
        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" v-bind:class="{ 'is-active': menuActive }" @click="menuToggle()" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active': menuActive }">
        <div class="navbar-start">
                <router-link to="/home" class="navbar-item">
                    <i class="fas fa-home"></i>{{ $t("message.header_home") }}
                </router-link>
                <router-link to="/write" class="navbar-item">
                    <i class="fas fa-edit"></i>{{ $t("message.header_write") }}
                </router-link>
                <router-link to="/archive" class="navbar-item">
                    <i class="fas fa-book"></i>{{ $t("message.header_archive") }}
                </router-link>
                <router-link to="/like" class="navbar-item">
                    <i class="fas fa-star"></i>{{ $t("message.header_like") }}
                </router-link>

                <router-link v-if="this.$i18n.locale == 'ja'" to="/articles" class="navbar-item">
                    <i class="far fa-newspaper"></i>{{ $t("message.header_magazin") }}
                </router-link>
                <router-link v-if="this.$i18n.locale == 'en' " to="/en/articles" class="navbar-item">
                    <i class="far fa-newspaper"></i>{{ $t("message.header_magazin") }}
                </router-link>
                
                <router-link to="/notices" class="navbar-item">
                    <i class="fas fa-bell"></i>{{ $t("message.header_info") }}
                </router-link>
        </div>


        <div class="navbar-end">
                <hr>
                <div class="buttons">
                    <router-link to="/login" v-if='!userStatus'>
                    <b-button class="is-info">
                        {{ $t("message.header_login") }}
                    </b-button>
                    </router-link>
                    <b-button @click="logout" v-if='userStatus' type="is-text">
                        <i class="fas fa-sign-out-alt"></i>{{ $t("message.header_logout") }}
                    </b-button>
                </div>

        </div>
    </div>
    </nav>
</template>

<script>
import firebase from 'firebase/app'
import store from '@/store'
export default {
    data(){
        return{
            menuActive:false,
        }
    },
    computed: {
        userStatus() {
            return this.$store.getters.isSignIn;
        },
        user(){
            return this.$store.getters.user;
        },
    },
    watch:{
        '$route' () {
            this.menuActive = false
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(function(user) {
            if(user) {
                store.commit('onAuthStateChanged', user);
                store.commit('onUserStatusChanged', user.uid ? true : false);
            }
        });
    },
    methods:{
        logout(){
            this.$buefy.dialog.confirm({
            message: 'ログアウトしますか？',
            onConfirm: () =>  
                firebase.auth().signOut().then(()=>{
                    this.$buefy.toast.open('ログアウトしました');
                    this.$router.go({ name: '/' })
                })
            })
        },
        menuToggle(){
            this.menuActive = !this.menuActive;
        },
    }
}
</script>

<style scoped>
nav{
    padding-left: 20px;
    padding-right: 20px;
}
hr{
    margin:6px;
}
.login_button{
    color: white;
}
</style>